<!-- 2024-7-22 新增指标信息 -->
<script setup>
import { ref, watch, defineExpose, defineProps, toRefs, inject, } from "vue"
import groupCom from "./common/group.vue"
import swiperTab from "@/components/common/swiperTab.vue";
// import { useRoute } from "vue-router";
import { getLangValue } from "@/utils/common"; //获取后端语言
const props = defineProps({
    groupList: {
        type: Object,
        required: true,
        default: () => ({})
    },
    p_id: {
        type: String,
        required: true,
        default: ''
    },
})
const { groupList, p_id } = toRefs(props)
const groupList2 = ref([])
const groupList3 = ref([])
const indicatorstandardsList = ref([]);
const activeIndex = ref(0)
const index_standards_list = inject('index_standards_list') // 指标数据
const currentTabLang = inject('currentTabLang') //切换语言
const current_tab = ref('')
const current_tab1 = ref('')
const current_tab2 = ref('')
const loading = ref(false)
const onAddgroupindicator = () => {
    // 新增  已取消
    let m = {
        name: '',
        value: '',
        unit: '',
        reference: '',
        isNewAdd: true
    }
    indicatorstandardsList.value[activeIndex.value].indicatorList.push(m)
}
const isCheckForm = ref(false)
const onDeleteGroupindicator = (i) => {
    // 删除  已取消
    indicatorstandardsList.value[activeIndex.value].indicatorList.splice(i, 1)
}

const changTab = () => {
    // 根据current_tab 设置子集信息
    // console.log(current_tab.value);
    let arr = current_tab.value.split('_');
    if (arr.length == 2) {
        // 代表第一级  需要联动第二级  第三级
        // 第二级
        groupList2.value = groupList.value.groupList2.filter(item => item.id.includes(current_tab.value));
        // 第三级
        groupList3.value = groupList.value.groupList3.filter(item => item.id.includes(current_tab.value));
        current_tab1.value = ''
        current_tab2.value = ''
    } else if (arr.length == 3) {
        // 代表第二级  需要联动第三级
        // 第三级
        groupList3.value = groupList.value.groupList3.filter(item => item.id.includes(current_tab.value));
        current_tab2.value = ''
    }
}

// const getIndicatorStands = async (id) => {
//     // 获取指标信息
//     const resp = await getDataBaseIndexStandard({ hscode_id: id });
//     if (resp.payload !== null) {
//         // if (resp.payload !== null) {
//         indicatorstandardsList.value = []
//         for (let k in resp.payload) {
//             console.log(k);
//             let m = {
//                 level: resp.payload[k],
//                 groupName: k,
//                 indicatorList: resp.payload[k] ? resp.payload[k] : [],
//             }
//             indicatorstandardsList.value.push(m)
//         }
//     }
// }

// const checkForm = () => {
//     let checkRes = true;
//     isCheckForm.value = true;
//     for (const item in indicatorstandardsList.value) {
//         const { indicatorList } = indicatorstandardsList.value[item]
//         // const arr = indicatorList.filter(item => item.isNewAdd)
//         for (const item1 in indicatorList) {
//             // const { name,testing_institution ,qualification_of_testing_institution, has_report } = indicatorList[item1]
//             // if (!name) {
//             //     checkRes = false;
//             //     break;
//             // }
//             // if (!testing_institution) {
//             //     checkRes = false;
//             //     break;
//             // }
//             // if (!qualification_of_testing_institution) {
//             //     checkRes = false;
//             //     break;
//             // }
//             // if (!has_report) {
//             //     checkRes = false;
//             //     break;
//             // }
//         }
//     }
//     return checkRes
// }

// const changeIndicator = (i) => {
//     activeIndex.value = i;
// }

// watch(current_hscode, (val) => {
//     // console.log('当钱选中的hscode', val)
//     // if(!route.query.id){
//     // console.log(val);
//     if (val && val.length) {
//         const arr = JSON.parse(JSON.stringify(val))
//         getIndicatorStands(arr.pop())
//     } else {
//         indicatorstandardsList.value = []
//     }
//     // }

// })

// watch(detailInfo, (val) => {
//     // 重新生成指标标准
//     indicatorstandardsList.value = []
//     const { index_standard_info } = val;
//     if (!index_standard_info || index_standard_info == null || Object.keys(index_standard_info).length == 0) return
//     for (let k in index_standard_info.value) {
//         let m = {
//             groupName: k,
//             indicatorList: index_standard_info.value[k] ? index_standard_info.value[k] : [],
//         }
//         indicatorstandardsList.value.push(m)
//     }
// })

// onMounted(() => {
//     console.log(index_standards_list.value);
// })
watch(groupList, () => {
    // 设置一级信息 设置二级信息
    if (groupList.value.groupList2)
        groupList2.value = groupList.value.groupList2.filter(item => item.id.includes(p_id.value))
    if (groupList.value.groupList3)
        groupList3.value = groupList.value.groupList3.filter(item => item.id.includes(p_id.value))
    // 默认显示第一级数据
    current_tab.value = p_id.value
    // console.log(groupList);
}, { deep: true, immediate: true })

const onActiveTabId = (id) => {
    // 切换
    current_tab.value = id;
}

watch(current_tab, () => {
    changTab();
})

// watch(() => indicatorstandardsList.value.length, (val) => {
//     if (val == 0) {
//         tabList.value[2].show = false;
//         current_tab.value = 0
//     } else {
//         tabList.value[2].show = true;
//     }
// }, { immediate: true })

defineExpose({
    // checkForm,
    indicatorstandardsList,
    current_tab
})
</script>
<template>
    <swiperTab @onActiveTabId="onActiveTabId" class="ms-4" :groupList="groupList2" v-model:current_tab="current_tab1"
        :tabKey="'group2'" :currentTabLang="currentTabLang" />
    <swiperTab @onActiveTabId="onActiveTabId" class="ms-6" :groupList="groupList3" v-model:current_tab="current_tab2"
        :tabKey="'group3'"  :currentTabLang="currentTabLang"/>
    <div v-if="index_standards_list[current_tab].indicatorList.length" v-loading="loading">
        <div class="card my-4">
            <!-- v-if="indicatorstandardsList[current_tab] && $route.query.type !== 'view'" -->
            <groupCom :isCheckForm="isCheckForm" :indicatorList="index_standards_list[current_tab].indicatorList"
                @onAddgroupindicator="onAddgroupindicator" @onDeleteGroupindicator="onDeleteGroupindicator" />
        </div>
    </div>
    <Empty v-else :content="getLangValue('base.no_indicator_data')" style="margin: 20px 0 !important;"></Empty>
</template>

<style scoped>
.active {
    color: #0AB39C
}
</style>